import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

const HowToAccordion = () => {
  const { t } = useTranslation('howto');
  const sections = t('sections', { returnObjects: true });
  const [openIds, setOpenIds] = useState(() => new Set());

  if (!Array.isArray(sections)) {
    return null;
  }

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div className="howto-accordion">
      {sections.map((section) => {
        const isOpen = openIds.has(section.id);
        const steps = Array.isArray(section.steps) ? section.steps : [];

        return (
          <div
            key={section.id}
            className={`howto-accordion-item${isOpen ? ' is-open' : ''}`}
          >
            <button
              type="button"
              className="howto-accordion-trigger"
              onClick={() => toggle(section.id)}
              aria-expanded={isOpen}
              aria-controls={`howto-panel-${section.id}`}
              id={`howto-trigger-${section.id}`}
            >
              <span>{section.title}</span>
              <ChevronDown size={20} className="howto-accordion-chevron" aria-hidden />
            </button>

            <div
              id={`howto-panel-${section.id}`}
              role="region"
              aria-labelledby={`howto-trigger-${section.id}`}
              className="howto-accordion-panel"
              hidden={!isOpen}
            >
              {section.intro ? <p>{section.intro}</p> : null}
              {steps.length > 0 && (
                <ol className="howto-steps-list">
                  {steps.map((step, index) => (
                    <li key={`${section.id}-step-${index}`}>{step}</li>
                  ))}
                </ol>
              )}
              {section.note ? <p className="howto-section-note">{section.note}</p> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HowToAccordion;
